import template from './notify-match.pug';

export const ItemNotifyMatchComponent = {
  template,
  bindings: {
    notification: '<',
    onOpenPreview: '&'
  },
  controller: class ItemNotifyMatchComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {}

    previewClick() {
      this.onOpenPreview({
        $event: this.notification
      });
    }
  }
};
